import React, { useEffect, useState } from 'react';
import KeyValuePair from 'helpers/KeyValuePair';
import axios from 'axios';

interface IApplicationContext {
    isLoading: boolean
    countries: KeyValuePair<string, string>[]
}

export let applicationContext = React.createContext({} as IApplicationContext);

let { Provider } = applicationContext;

let ApplicationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [countries, setCountries] = useState<KeyValuePair<string, string>[]>([]);


    useEffect(() => {
        getApplicationData();
    }, [])


    let getApplicationData = async () => {
        try {
            setLoading(true);
            let res = await axios.get('/api/ReferenceData/GetReferenceData');

            let { item } = res.data;
            setCountries(item.countries);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }


    return (
        <Provider
            value={{
                isLoading,
                countries
            }}
        >
            {children}
        </Provider>
    )
}

export default ApplicationProvider;